import { useMemo } from 'react';
import { VariantPackInfoContext_GroupBadgeFieldsFragment } from '@/types';

export const sortBadgesByPriority = (
  badges: VariantPackInfoContext_GroupBadgeFieldsFragment[],
) =>
  [...badges].sort((a, b) => {
    const aPriority = a.sort_order ?? Infinity;
    const bPriority = b.sort_order ?? Infinity;
    if (aPriority !== bPriority) {
      return aPriority - bPriority;
    }
    return a.name.localeCompare(b.name);
  });

export const useBadgeOverflow = (
  badges: VariantPackInfoContext_GroupBadgeFieldsFragment[] | undefined,
  maxVisible: number | undefined,
) => {
  const sortedBadges = useMemo(
    () => sortBadgesByPriority(badges || []),
    [badges],
  );

  const hasOverflow =
    maxVisible !== undefined && sortedBadges.length > maxVisible;
  const visibleBadges = hasOverflow
    ? sortedBadges.slice(0, maxVisible - 1)
    : maxVisible !== undefined
      ? sortedBadges.slice(0, maxVisible)
      : sortedBadges;
  const overflowCount = hasOverflow
    ? sortedBadges.length - (maxVisible - 1)
    : 0;

  return { overflowCount, sortedBadges, visibleBadges };
};
